<script lang="ts">
    import type {ToastMessage} from 'shared/components/kp-toast-messages/types';
    import type {MessageReceivedEventData} from 'src/features/threads/threads.types';
    import {getInjector} from 'core/svelte-context/context';
    import {ThreadsContextService} from 'src/features/threads/services/threads-context.service';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {OPEN_THREAD_POPOVER_EVENT} from 'src/features/threads/threads.constants';
    import ToastMessageCardContainer from 'shared/components/kp-toast-messages/ToastMessageCardContainer.svelte';
    import KpUserAvatar from 'shared/components/kp-user-avatar/KpUserAvatar.svelte';
    import Flex from 'shared/layouts/flex/Flex.svelte';
    import Spacer from 'shared/layouts/flex/Spacer.svelte';

    export let toast: ToastMessage;
    export let messageData: MessageReceivedEventData;

    const threadsContextService = getInjector().getByClass(ThreadsContextService);

    const handleToastClick = () => {
        threadsContextService.eventBus.dispatchEvent(new CustomEvent(OPEN_THREAD_POPOVER_EVENT, {detail: messageData.threadId}));
    };

    function getMessageContent(): string {
        if (messageData.message.content.length < 50) {
            return messageData.message.content;
        }

        return `${messageData.message.content.substring(0, 50)}...`;
    }
</script>

<ToastMessageCardContainer {toast} on:toast-click={handleToastClick}>
    <KpUserAvatar user="{messageData.message.senderUser}" sizePx="{24}"/>

    <Flex direction="column" alignItems="flex-start">
        <span class="sender-name">{pipe(messageData.message.senderUser, loc())}</span>
        <small class="thread-name">Posláno v {messageData.threadName}</small>
        <Spacer direction="vertical" size="xs"/>
        <span class="message-content">{getMessageContent()}</span>
    </Flex>
</ToastMessageCardContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    span,
    small {
        text-align: start;
    }

    .sender-name {
        font-weight: 500;
    }

    .thread-name {
        color: @themed-text-muted;
        font-size: @font-size-xs;
    }
</style>